import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../constants/common'
import { FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION } from '../../../../constants/form'
import { toBuildingGroupSelectItems } from '../../../BuildingGroup'
import { getEntityActionTypeSelectOptions } from '../../../Entity'
import { FormModal } from '../../../Form'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../../Formik'
import { MODAL_HEADER_VARIANT } from '../../../Modal'

import { QA_NAME_EDIT_BUILDINGS_GROUP_MODAL } from './BuildingsEditBuildingsGroupActionModal.constants'
import {
  getInitialValues,
  getSubmitPayload,
  getValidationSchema,
} from './BuildingsEditBuildingsGroupActionModal.utils'
import { FormFields } from './FormFields'

function BuildingsEditBuildingsGroupActionModal({
  formFieldsProps: {
    actionTypes = Object.values(getEntityActionTypeSelectOptions()),
    ...formFieldsProps
  } = EMPTY_OBJECT,
  itemAction,
  items = EMPTY_LIST,
  onClose,
  onSubmit,
}) {
  const initialValues = getInitialValues(
    toBuildingGroupSelectItems(items),
    itemAction
  )

  const validationSchema = getValidationSchema({ initialValues, itemAction })

  function handleSubmit({ value, values }) {
    onSubmit({
      actionType: values[FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME],
      value,
    })
  }

  return (
    <FormModal
      Fields={FormFields}
      containerProps={{
        headerVariant: MODAL_HEADER_VARIANT.EDIT,
        qaName: QA_NAME_EDIT_BUILDINGS_GROUP_MODAL,
      }}
      formBodyProps={FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION}
      formFieldsProps={{ ...formFieldsProps, actionTypes }}
      formTitle='Modal.EditBuildingsGroupTitleKey'
      getPayload={getSubmitPayload}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default BuildingsEditBuildingsGroupActionModal
